var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatalog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8 19.7067H5.26667C2.93333 19.7067 1 17.84 1 15.5V5.20667C1 2.87333 2.93333 1 5.27333 1H15.6533C17.9933 1 19.9267 2.87333 19.9267 5.20667V5.58C22.92 5.58 24.7 7.17333 24.7 10.2867C27.0667 10.2867 29 12.1267 29 14.4933V24.7533C29 27.0933 27.1 28.9933 24.76 28.9933H14.28C11.9733 28.9933 10.0733 27.0933 10.0733 24.7533V24.2533C7.64 24.0333 5.8 22.66 5.8 20.0733V19.7067ZM23.1067 10.2933V9.79333C23.1067 8.32667 21.8933 7.17333 20.4533 7.17333H10.04C8.57333 7.17333 7.36 8.32667 7.36 9.79333V20.08C7.36 21.7667 8.51333 22.5133 10.0733 22.6667V14.5C10.0733 12.1933 11.9733 10.2933 14.28 10.2933H23.1067ZM24.76 11.8533H14.28C12.8467 11.8533 11.66 13.04 11.66 14.5067V24.7667C11.66 26.2333 12.8467 27.42 14.28 27.42H24.7533C26.22 27.42 27.4067 26.2333 27.4067 24.7667V14.5C27.4067 13.0333 26.2267 11.8533 24.76 11.8533ZM18.3333 5.58667V5.21333C18.3333 3.74667 17.12 2.59333 15.6533 2.59333H5.27333C3.80667 2.59333 2.59333 3.74667 2.59333 5.21333V15.5C2.59333 16.9667 3.80667 18.12 5.27333 18.12H5.80667V9.79333C5.80667 7.45333 7.74 5.58667 10.0467 5.58667H18.3333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalog);
export default __webpack_public_path__ + "static/media/catalog.d2dcbf8bef89c444a2dd182d2d9b637f.svg";
export { ForwardRef as ReactComponent };